import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "@heroicons/react/24/outline";

import {
  deleteCategoryById,
  fetchAllCategory,
} from "../../../../redux/reducer/categoryReducer";
import CategoriesTableDetails from "./CategoriesTableDetails";
import AddCategoryForm from "./AddCategoryForm";

const CategoriesSettings = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);
  const dispatch = useDispatch();
  const { allCategories, loading, error } = useSelector(
    (state) => state.categories
  );
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false); // <-- toggle form

  const [selectedArea, setSelectedArea] = useState("");
  const [filteredCategory, setFilteredCategory] = useState([]);

  const headers = ["ID", "Name EN", "Name AR", "image", "area", "Actions"];

  useEffect(() => {
    if (selectedArea) {
      const filtered = allCategories.filter((subCategory) => {
        return !selectedArea || subCategory.area?._id === selectedArea;
      });
      setFilteredCategory(filtered);
    } else {
      setFilteredCategory(allCategories);
    }
  }, [selectedArea, allCategories]);

  useEffect(() => {
    const fetchData = async () => {
      // console.log("Waiting 3 seconds...");

      // console.log("Dispatching fetchAllBrand...");
      await dispatch(fetchAllCategory());
    };

    fetchData();
  }, [dispatch]);

  const loadCategory = async () => {
    try {
      await dispatch(fetchAllCategory()).unwrap();
    } catch (error) {
      console.error("Failed to fetch the Categories:", error);
    }
  };

  const handleDelete = (categoryId) => {
    if (window.confirm("Are you sure you want to delete this Category?")) {
      dispatch(deleteCategoryById(categoryId))
        .unwrap()
        .then(() => {
          alert(t("categoryDeleted"));
          dispatch(fetchAllCategory());
        })
        .catch((error) => alert(error || "Failed to delete Category."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllCategory());
  };

  // console.log(allCategories)
  return (
    <div className="mx-auto overflow-x-auto rounded-xl">
      <div className="flex justify-between my-4">
        <h1 className="text-xl font-bold text-black">Categories</h1>

        <div>
          <div className="flex flex-wrap gap-3 ">
            {/* Area Filter */}
            <select
              className="p-2 text-black bg-white border rounded-md disabled:bg-gray-700 disabled:text-gray-200"
              value={selectedArea}
              onChange={(e) => setSelectedArea(e.target.value)}
            >
              <option value="" className="text-black">
                Filter by Area
              </option>
              {[...new Set(allCategories.map((b) => b.area?._id))].map((id) => {
                const name = allCategories.find((b) => b.area?._id === id)?.area
                  ?.name?.en;
                return (
                  <option key={id} value={id} className="text-black">
                    {name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <button
          className="flex gap-3 px-3 py-2 duration-300 rounded-lg bg-custom-yellow hover:bg-black group"
          onClick={() => {
            setShowForm(true);
          }}
        >
          <PlusIcon className="w-6 h-6 text-black group-hover:text-white" />
          <span className="text-black group-hover:text-white">Category</span>
        </button>
      </div>

      {loading ? (
        <p className="text-center text-gray-600">{t("Loading...")}</p>
      ) : error ? (
        <p className="text-center text-red-500">
          {t("Error")}: {error}
        </p>
      ) : allCategories?.length === 0 ? (
        <p className="text-center text-gray-500">{t("No data found")}</p>
      ) : (
        <table className="w-full my-5">
          <thead>
            <tr className="text-sm text-black bg-custom-yellow">
              {headers.map((header, index) => (
                <th key={index} className="px-2 py-2 font-bold text-center">
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {filteredCategory?.map((category, index) => (
              <CategoriesTableDetails
                key={category._id || index}
                index={index + 1}
                details={{
                  id: category._id,
                  number: index + 1,
                  img: category.img,
                  area: category.area?._id,
                  areaName: category.area?.name?.en,
                  nameEN: category.title?.en,
                  nameAR: category.title?.ar,
                }}
                isEditing={editingOrder === category._id}
                isPricing={pricingOrder === category._id}
                setEditingOrder={setEditingOrder}
                setPricingOrder={setPricingOrder}
                onUpdate={handleUpdate}
                onDelete={() => handleDelete(category._id)}
              />
            ))}
          </tbody>
        </table>
      )}
      {showForm && (
        <AddCategoryForm
          onClose={() => {
            setShowForm(false);
            loadCategory();
          }}
        />
      )}
    </div>
  );
};

export default CategoriesSettings;
